import { FC } from 'react';
import clsx from 'clsx';
import { IUnbutton } from '../../../types';
import styles from './unbutton.module.css';

const Unbutton: FC<IUnbutton> = props => {
  const {
    type = 'button',
    className = '',
    size = 'normal',
    fullwidth = false,
    isLoading = false,
    variant = 'default',
    children,
    ...rest
  } = props;

  // normalize size
  // eslint-disable-next-line
  const sizeClass =
    size === 'small'
      ? 'is-small'
      : size === 'medium'
        ? 'is-medium'
        : size === 'large'
          ? 'is-large'
          : 'is-normal';

  const fullwidthClass = fullwidth ? 'is-fullwidth' : '';

  const loadingClass = isLoading ? 'is-loading' : '';

  // eslint-disable-next-line
  const variantClass = variant === 'default' ? '' : styles[variant];

  return (
    <button
      type={type}
      className={clsx(
        'button',
        styles.base,
        sizeClass,
        fullwidthClass,
        loadingClass,
        variantClass,
        className
      )}
      {...rest}>
      {children}
    </button>
  );
};

export default Unbutton;
